import React from "react";
import firebase from "firebase";

import { StyleSheet, css } from "aphrodite";

import Modal from "react-modal";

import EditPicture from "./EditPicture";
import Inputs from "./Inputs";
import Nav from '../../components/Nav/Nav'
import { connect } from "react-redux";
import Spinner from "react-spinkit";
const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "860px"
  }
};

class PictureManagement extends React.Component {
  constructor(props) {
    super(props);
    if (firebase.apps.length === 0) {
      const config = {
        apiKey: "AIzaSyCe_Xt__m4WQKhBd6sKizvh3imEQReXA0g",
        authDomain: "picnowtest.firebaseapp.com",
        databaseURL: "https://picnowtest.firebaseio.com",
        storageBucket: "picnowtest.appspot.com",
        messagingSenderId: "323233553771"
      };
      firebase.initializeApp(config);
    }
  }

  state = {
    toggleAdd: false,
    loading: false,
    modalIsEditOpen: false
  };

  loadData = () => {
    const { universityFirebase } = this.props;
    this.setState({ loading: true }, () => {
      firebase
        .database()
        .ref(`${universityFirebase}/dressCodes`)
        .once("value")
        .then(async snapshot => {
          let data = snapshot.val();
          const keys = Object.keys(snapshot.val());

          for (let i = 0; i < keys.length; i++) {
            const facultyName = await firebase
              .database()
              .ref(`${universityFirebase}/faculties/${data[keys[i]].facultyId}`)
              .once("value");
            data[keys[i]].facultyName = facultyName.val();
            
          }
          this.setState({ loading: false, toggleAdd: false, data });
        })
        .catch(error => {
          alert("Something when wrong");
          console.error("Error", error);
          this.setState({ loading: false, toggleAdd: false });
        });
    });
  };

  componentDidMount() {
    this.loadData();
  }

  onAddBtnClick = event => {
    this.setState({
      toggleAdd: !this.state.toggleAdd
    });
  };

  //Working
  handleRemove = async (event, dressCode) => {
    const { universityFirebase } = this.props;
    let confirm = window.confirm(`Delete this dresscode ${dressCode}?`);
    if (confirm) {
      try {
        await firebase
          .database()
          .ref(`/${universityFirebase}/dressCodes/${dressCode}`)
          .remove();
      } catch (e) {
        console.log("error", e);
      }
      this.loadData();
    }
  };

  handleEdit = (event, dressCode) => {
    const { data } = this.state;
    const modalPictureInfo = data[dressCode];
    this.setState({
      modalIsEditOpen: true,
      modalPictureInfo
    });
  };

  getTable = () => {
    const { loading, data } = this.state;

    if (!loading) {
      if (data) {
        return Object.values(this.state.data).map((data, i) => {
          return (
            <tr key={i}>
              <td>{data.dressCode}</td>
              <td>{data.facultyName}</td>
              <td>
                <img alt={'รูปผู้ชาย'} className={"img-example"} src={data.maleImageUrl} />
              </td>
              <td>
                <img alt={'รูปผู้หญิง'} className={"img-example"} src={data.femaleImageUrl} />
              </td>
              <td>
                <button className="btn btn-sm btn-success" onClick={event => this.handleEdit(event, data.dressCode)}>
                  Edit
                </button>
              </td>
              <td>
                <button className="btn btn-sm btn-danger" onClick={event => this.handleRemove(event, data.dressCode)}>
                  Remove
                </button>
              </td>
            </tr>
          );
        });
      } else {
        return (
          <tr>
            <td className={"text-center"} colSpan={6}>
              ไม่พบข้อมูล
            </td>
          </tr>
        );
      }
    } else {
      return (
        <tr>
          <td className={"text-center"} colSpan={6}>
            <Spinner name={"three-bounce"} color={"#0070bf"} className={`${css(styles.loading)}`} />
          </td>
        </tr>
      );
    }
  };

  renderModal = () => {
    const { modalIsEditOpen, modalPictureInfo } = this.state;
    const { universityFirebase } = this.props;
    return (
      <Modal contentLabel="Modal" isOpen={modalIsEditOpen} style={modalStyles}>
        <EditPicture
          universityFirebase={universityFirebase}
          modalPictureInfo={modalPictureInfo}
          updateTable={this.loadData}
          closeModal={() => this.setState({ modalIsEditOpen: false })}
        />
      </Modal>
    );
  };

  render() {
    const { toggleAdd, loading } = this.state;
    const { universityFirebase } = this.props;
    return (
      <div>
        <Nav/>
        {this.renderModal()}
        {!loading && (
          <button className="btn btn-primary" onClick={this.onAddBtnClick}>
            Add Input
          </button>
        )}
        <br />
        <br />
        {toggleAdd && <Inputs universityFirebase={universityFirebase} updateTable={this.loadData} />}

        <br />

        <table className="table table-hover">
          <thead>
            <tr>
              <th>รหัสชุด</th>
              <th>ชื่อคณะ</th>
              <th>รูปชุดครุยผู้ชาย</th>
              <th>รูปชุดครุยหญิง</th>
              <th />
              <th />
            </tr>
          </thead>
          <tbody>{this.getTable()}</tbody>
        </table>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    fontSize: 28,
    lineHeight: "1.2",
    margin: "0 0 1.5rem"
  },
  lead: {
    fontSize: 18,
    lineHeight: "1.5",
    margin: "0 0 1.5rem",
    color: "#555"
  },
  body: {
    fontSize: "1rem",
    lineHeight: "1.5",
    margin: "0 0 1.5rem",
    color: "#555"
  },
  list: {
    fontSize: "1rem",
    listStyle: "none",
    padding: 0
  },
  loading: {
    marginTop: "20px",
    marginBottom: "20px"
  }
});

const mapStateToProps = state => {
  return { universityFirebase: state.auth.universityFirebase };
};

export default connect(mapStateToProps)(PictureManagement);



// WEBPACK FOOTER //
// /src/containers/PictureManagement/PictureManagement.js